import { SubComponentModel } from '@secca/case/components/case-plans/case-plans/add-service-order/models/interfaces';

export class SubRemarksToSupplier implements SubComponentModel {
  remarks: string;

  public constructor(init?: Partial<SubRemarksToSupplier>) {
    Object.assign(this, init);
  }

  isValid(): boolean {
    return true;
  }

}
